import React, { useEffect } from 'react'
import { isMobile } from 'react-device-detect'
import SaveIcon from 'client/utils/icons/save-icon'
import {
  DcButton,
  DcDiv,
  DcDropDown,
  DcFlexBox,
  DcInput,
  DcText,
  PixelCheckboxGroup,
  PixelFactoryContext,
  PixelFlexBox,
} from 'pixel-base'

import { updateUser } from 'utils/api-routes.util'
import { IPixelFactory, IUser } from '../../../../../../decl.d'

const EditUserInfo = (props: {
  userRole: { description: string; id: string }[]
  handleClose: (data: IUser) => void
  user: {
    id: string
    name: string
    user_email: string
    active: boolean
    user_type: { id: string }
  }
}) => {
  const { showPageLoader, hidePageLoader, showSuccess, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const { userRole, handleClose, user } = props
  const [error, setError] = React.useState({
    error: '',
    field: '',
  })
  const [data, setData] = React.useState({
    name: '',
    username: '',
    role_id: '',
    email: '',
    active: 1,
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    handleAddBusinness()
  }

  const handleAddBusinness = () => {
    showPageLoader()
    updateUser(data).subscribe((res: any) => {
      hidePageLoader()
      if (res.response.data) {
        showSuccess('Successfully Added')
        handleClose(res.response.data)
      } else {
        if (res.response.error && res.response.field) {
          setError({
            error: res.response.error,
            field: res.response.field,
          })
        } else {
          showFailure(res.response.error)
        }
      }
    })
  }

  useEffect(() => {
    user.email = user.user_email
    user.active = user.active === false ? 0 : 1
    user.role_id = user.user_type.id
    setData(user)
  }, [user])
  return (
    <>
      <form
        style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
        onSubmit={handleSubmit}
      >
        <PixelFlexBox
          flexDirection={isMobile ? 'column' : 'row'}
          justifyContent={'flex-start'}
          gap="10px"
          width="100%"
          style={{ flexGrow: 1 }}
        >
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Full Name
            </DcText>
            <DcInput
              tabIndex={1}
              error={
                error.field === 'name' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'text'}
              name={'name'}
              placeholder={'Full Name'}
              value={data.name}
              onChange={(e) => setData({ ...data, name: e.target.value })}
            />
          </DcDiv>
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Email
            </DcText>
            <DcInput
              error={
                error.field === 'email' && error.error !== ''
                  ? error.error
                  : null
              }
              disabled
              tabIndex={2}
              required
              type={'email'}
              name={'email'}
              placeholder={'Email'}
              value={data.email}
              onChange={(e) => setData({ ...data, email: e.target.value })}
            />
          </DcDiv>
        </PixelFlexBox>
        <PixelFlexBox
          flexDirection={isMobile ? 'column' : 'row'}
          justifyContent={'flex-start'}
          gap="10px"
          width="100%"
          style={{ flexGrow: 1 }}
        >
          <PixelFlexBox
            width={isMobile ? '100%' : '378px'}
            flexDirection="row"
            justifyContent="flex-start"
          >
            <DcDiv
              width="100%"
              height="auto"
              style={{
                display: 'flex',

                flexDirection: 'column',
                alignItems: 'flexStart',
              }}
            >
              <DcText
                style={{
                  textAlign: 'left',

                  color: '#2e314a',
                  fontSize: '.875rem',
                  fontWeight: '500',
                  marginBottom: '.5rem',
                }}
              >
                Role
              </DcText>
              <DcDropDown
                tabIndex={3}
                error={
                  error.field === 'role' && error.error !== ''
                    ? error.error
                    : null
                }
                options={[
                  ...userRole,
                  { description: 'Select Role', id: '' },
                ].map((data) => {
                  return { label: data.description, value: data.id }
                })}
                placeholder={'User Role'}
                name={'User Role'}
                value={data.role_id}
                onChange={(e) => setData({ ...data, role_id: e.target.value })}
              />
            </DcDiv>
          </PixelFlexBox>
          <DcFlexBox height="auto" width="50%" alignItems="center" gap="10px">
            <PixelCheckboxGroup
              label="Is Active?"
              tabIndex={4}
              options={[
                {
                  label: 'Yes',
                  value: 1,
                  type: 'radio',
                  checked: data.active === 1,
                },
                {
                  label: 'No',
                  value: 0,
                  type: 'radio',
                  checked: data.active === 0,
                },
              ]}
              onChange={(e) => {
                setData({ ...data, active: Number(e.target.value) })
              }}
            />
          </DcFlexBox>
        </PixelFlexBox>
        <PixelFlexBox
          flexDirection={isMobile ? 'column' : 'row'}
          justifyContent={'flex-end'}
          gap="10px"
          width="100%"
          style={{ flexGrow: 1 }}
        >
          <DcButton
            variant="primary"
            type="submit"
            tabIndex={5}
            withIcon={true}
            size="sm"
          >
            <SaveIcon size={16} />
            <span>Save</span>
          </DcButton>
        </PixelFlexBox>
      </form>
    </>
  )
}

export default EditUserInfo
